import { render } from "./TradingTrials.vue?vue&type=template&id=58df115c&scoped=true"
import script from "./TradingTrials.vue?vue&type=script&lang=js"
export * from "./TradingTrials.vue?vue&type=script&lang=js"

import "./TradingTrials.vue?vue&type=style&index=0&id=58df115c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58df115c"]])

export default __exports__